import React from 'react'

const BulkActionContext = React.createContext()
export default BulkActionContext
